import _ from 'lodash';
import { defaultLanguage } from '../../../../locales/locales';

export const languageSelector = (state) => _.get(state, 'global.i18n.lang', defaultLanguage);
